<template>
  <div class="card ticket-chat">
    <div class="chat-head"  :class="readPriorita()" v-if="ticket">
      <div class="title">
        <PriorityDot :priorita="ticket.priorita"/>
        <div>
          <h4>{{ ticket.titolo }}</h4>
          <b>{{ ticket.numero_progressivo }}</b>
        </div>
      </div>
      <div class="ticket-info">
        <div>
          <Tag :value="tagStatoValue()" :severity="tagStatoSeverity()"/>
        </div>
        <AssegnatariCircles :assegnatari="assegnatari"/>
      </div>
    </div>
    <div class="messages-container" ref="messagesContainer" v-if="ticket">
        <template v-if="need_modifca">

          <MessaggioChat :message="messaggio_errore"  />
        </template>
        <template v-else>
          <!-- Messaggio principale del ticke -->
          <MessaggioChat :message="ticket"  />

          <!-- Thread del ticket -->
          <template v-for="t in thread" :key="t.id">
            <MessaggioChat :ruolo="ruolo" :message="t"  />
          </template>
        </template>



    </div>
    <div class="answers-container" v-if="!is_confermato && !is_completato && allow_reply">
      <Input v-model="messaggio" placeholder="Invia una risposta rapida..." class="w-full" @keyup.enter="inviaMessaggio" :readonly="readonly"/>
      <Button v-if="!readonly" icon="pi pi-send" @click="inviaMessaggio" class="p-button-outlined p-button-primary !rounded-full" ></Button>
    </div>
  </div>
</template>

<script>
import PrimeDrawer from 'primevue/drawer';
import Button from 'primevue/button';
import Input from 'primevue/inputtext';
import Tag from 'primevue/tag';
import PriorityDot from './PriorityDot.vue';
import AssegnatariCircles from './AssegnatariCircles.vue';

export default {
  name: 'ThreadChat',
  components: {
    PrimeDrawer,
    PriorityDot,
    AssegnatariCircles,
    Button,
    Input,
    Tag
  },
  data(){
    return {
        ticket: null,
        thread: [],
        assegnatari: [],
        is_confermato: false,
        is_completato:false,
        messaggio: '',
        need_modifca: false,
        messaggio_errore: null,
        readonly: false
    }
  },
  beforeMount(){
    if(this.ticket_id != null){
        console.log(this.thread_route);
        axios.post(route(this.thread_route, {id: this.ticket_id}))
        .then((res)=>{
          if(res.data.success){

            console.log(res.data);

            this.ticket = res.data.ticket;
            this.ticket.messaggio = this.ticket.messaggio_originale
            this.ticket.tipo_post = "messaggio"
            this.ticket.avatar.ordine = "reverse";
            this.thread = res.data.thread;
            this.assegnatari = res.data.assegnatari;
            this.is_confermato = res.data.is_confermato;
            this.is_completato = res.data.is_completato;
            this.readonly = res.data.readonly;
            this.$nextTick(() => {
              console.log('Scrolling to bottom');
              const container = this.$refs.messagesContainer;
              if (container) {
                container.scrollTop = container.scrollHeight;
              }
            });
          }else{
            this.$toast.add({severity:'error', summary: 'Errore', detail: res.data.messaggio, life: 3000});
            this.need_modifca = true
            let messaggio = `<p>
                  ${this.$root.trans.ticket_info_aggiuntive_messaggio_chat}
                </p>`
              if(this.ruolo == 'admin'){
                messaggio += `<p>
                  ${this.$root.trans.ticket_aggiungi_info_dalla} <a class=" to-blue-800 underline" href="${route('ticketing/maschera',{id: this.ticket_id})}">${this.$root.trans.ticket_aggiungi_info_pagina_modifica}</a>
                </p>`;
              }else if(this.ruolo == 'dipendente'){
                messaggio += `<p>
                  ${this.$root.trans.ticket_aggiung_info_contatta_amministratore}
                </p>`;
              }
            this.messaggio_errore = {
              tipo_post: 'errore',
              messaggio: messaggio
            }
            console.error(res.data);
          }
        })
    }else{
        console.log('No ticket ID provided');
    }
  },
  props: [
    'ticket_id',
    'thread_route',
    'risposta_rapida_route',
    'allow_reply',
    'ruolo'
  ],
  methods: {
    tagStatoValue(){
      const stato = this.ticket.stato.replace(/ /g, '_').toLowerCase();

      if(stato === 'aperto') {
        return this.$root.trans.stato_ticket_aperto;
      } else if(stato === 'in_lavorazione') {
        return this.$root.trans.stato_ticket_in_lavorazione;
      } else if(stato === 'in_attesa') {
        return this.$root.trans.stato_ticket_in_attesa;
      } else if(stato === 'in_attesa_del_cliente') {
        return this.$root.trans.stato_ticket_in_attesa_del_cliente;
      } else if(stato === 'completato') {
        return this.$root.trans.stato_ticket_completato;
      } else if(stato === 'confermato') {
        return this.$root.trans.stato_ticket_confermato;
      } else if(stato === 'incompleto'){
        return this.$root.trans.stato_ticket_incompleto;
      } else {
        return this.$root.trans.stato_ticket_sconosciuto;
      }
    },
    tagStatoSeverity(){
      const stato = this.ticket.stato.replace(/ /g, '_').toLowerCase();

      if(stato === 'aperto') {
        return 'contrast';
      } else if(stato === 'in_lavorazione') {
        return 'info';
      } else if(stato === 'in_attesa') {
        return 'warning';
      } else if(stato === 'in_attesa_del_cliente') {
        return 'warning';
      } else if(stato === 'completato') {
        return 'success';
      } else if(stato === 'confermato') {
        return 'success';
      } else if(stato === 'incompleto'){
        return 'danger';
      } else {
        return 'danger';
      }
    },
    readPriorita(){
     return `priority-${this.ticket.priorita.toLowerCase()}`;
    },
    getAllegatoUrl(id, type){
      return route('ticketing/allegato', { id: id, tipo: type });
    },
    formatDate(value) {
      return new Date(value).toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },

    inviaMessaggio(){
      if(this.messaggio.trim() === ''){
        this.$toast.add({severity:'warn', summary: 'Attenzione', detail: this.$root.trans.ticket_messaggio_vuoto_warning, life: 3000});
        return;
      }

      axios.post(route(this.risposta_rapida_route), {
        ticket_id: this.ticket_id,
        messaggio: this.messaggio
      })
      .then((res)=>{
        console.log(this.thread);
        this.$toast.add({severity:'success', summary: 'Successo', detail: this.$root.trans.ticket_messaggio_successo, life: 3000});
        this.thread.push(res.data.post);
        console.log(this.thread);
        this.messaggio = '';
      })
      .catch((error)=>{
        console.error(error);
        this.$toast.add({severity:'error', summary: 'Errore', detail: this.$root.trans.ticket_messaggio_errore, life: 3000});
      });
    }
  }
}
</script>
